import React from 'react';
import * as flags from 'country-flag-icons/react/3x2';

interface FlagIconProps {
  countryCode: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

const FlagIcon: React.FC<FlagIconProps> = ({ 
  countryCode, 
  width = 20, 
  height = 15,
  style = {}
}) => {
  // Handle special case for "Other"
  if (countryCode === 'XX' || !countryCode) {
    return null;
  }

  // Get the flag component dynamically
  const FlagComponent = (flags as any)[countryCode.toUpperCase()];

  if (!FlagComponent) {
    return null;
  }

  return (
    <FlagComponent
      style={{ 
        width: `${width}px`, 
        height: `${height}px`,
        objectFit: 'cover',
        ...style 
      }}
    />
  );
};

export default FlagIcon;